import React from 'react';
import Lottie from 'lottie-react';
import './styles.css';
import animationData from '../../assets/loader2.json';

const Loader = () => {
  return (
    <div className="loader-container">
      <Lottie
        animationData={animationData}
        autoPlay
        alt="loader"
        className="loader-animation"
      />
    </div>
  );
};

export default Loader;
